/**
 * Renders the detail view of a creative challenge entry.
 *
 * @param {object} item
 *   The creative challenge entry data.
 * @param {string|array} classes
 *   The classes to add to the detail view container.
 * @return {*|jQuery}
 */
export default function renderDetailView(item, classes = '') {
  const content = [];
  const notEmpty = (s) => s && (typeof s === 'string') && (s.trim().length > 0);

  let location = '';
  const country = notEmpty(item.country) ? `<span class='country'>${item.country}</span>` : '';
  if (notEmpty(item.region) && notEmpty(item.city)) {
    location = [`${item.city} (${item.region})`, country].join(', ');
  } else {
    location = [item.city, item.region, country].filter((v) => notEmpty(v)).join(', ');
  }

  if (notEmpty(item.submitterName)) {
    content.push($('<div class="submitterName"></div>').html(`Submitted by <strong>${item.submitterName}</strong>`));
  }
  if (notEmpty(item.affiliation)) {
    content.push($('<div class="affiliation"></div>').html(item.affiliation));
  }
  if (notEmpty(location)) {
    content.push($('<div class="location"></div>').html(location));
  }
  if (notEmpty(item.description)) {
    content.push($('<h2 class="small mb-1"></h2>').html('Submitter\'s description'));
    content.push($('<div class="description"></div>').html(item.description));
  }
  if (notEmpty(item.credits)) {
    content.push($('<h2 class="small mb-1"></h2>').html('Credits'));
    content.push($('<div class="credits"></div>').html(item.credits));
  }
  content.push($('<a class="download mt-3" target="_blank"></a>')
    .attr('href', item.full)
    .text('Open in full resolution'));

  return $('<div class="row creative-challenge-details">')
    .addClass(classes)
    .append($('<div class="col-xl-8 col-lg-12 col-image"></div>')
      .append($('<img>')
        .addClass('img-fluid')
        .attr('src', item.image)
        .attr('alt', '')))
    .append($('<div class="col-xl-4 col-lg-12 col-content"></div>')
      .append(content));
}
